import { canv } from "@/canv/global.js";
import { Shape } from "../shape";

export class ShapePinFilledLeft extends Shape {
    defaultBorderWidth = 12;
    defaultColor = "#000000";

    setDrawStyle(_: any): void {}

    draw(
        x: number,
        y: number,
        w: number,
        h: number,
        shapeStyles: {
            color: string;
            borderColor: string;
            borderDashType: string;
            borderWidth: number;
        },
    ) {
        let r = h / 50;

        if (w < 2 * r) r = w / 2;
        if (h < 2 * r) r = h / 2;

        canv.ctx.save();
        canv.ctx.strokeStyle = shapeStyles.borderColor;
        canv.ctx.lineWidth = shapeStyles.borderWidth;
        canv.ctx.fillStyle =
            shapeStyles.color === "transparent" ? shapeStyles.borderColor : shapeStyles.color;
        canv.ctx.beginPath();

        canv.ctx.moveTo(x + r, y);
        canv.ctx.arcTo(x + w, y, x + w, y + h, r);
        canv.ctx.arcTo(x + w, y + h, x, y + h, r);
        canv.ctx.arcTo(x, y + h, x, y, r);
        canv.ctx.arcTo(x, y, x + w, y, r);
        canv.ctx.fill();
        canv.ctx.closePath();

        canv.ctx.lineCap = "round";
        canv.ctx.globalCompositeOperation = "destination-out";

        canv.ctx.beginPath();
        canv.ctx.moveTo(x + w * 0.3, y + h * 0.5);
        canv.ctx.lineTo(x + w * 0.75, y + h * 0.5);

        canv.ctx.moveTo(x + w * 0.3, y + h * 0.5);
        canv.ctx.lineTo(x + w * 0.45, y + h * 0.3);

        canv.ctx.moveTo(x + w * 0.3, y + h * 0.5);
        canv.ctx.lineTo(x + w * 0.45, y + h * 0.7);

        canv.ctx.stroke();
        canv.ctx.closePath();
        canv.ctx.restore();
    }

    getView(reason = "shapeToolSubMenu", bgColor = "white", borderColor = "black") {
        let width = 25;
        let height = 25;
        let fill = "white";
        let stroke = "black";

        if (reason === "shapeToolSubMenu") {
            width = 24;
            height = 24;
            fill = "transparent";
            stroke = "#7C7C91";
        } else if (reason === "shapeLibrary") {
            width = 30;
            height = 30;
        } else if (reason === "voteResult") {
            width = 170;
            height = 170;
            fill = bgColor;
            stroke = borderColor;
        }

        return `
            <svg width="${width}" height="${height}" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <path stroke="${fill}" fill="${stroke}" fill-rule="evenodd" d="M2.75 1.5c-.7 0-1.25.56-1.25 1.25v18.5c0 .7.56 1.25 1.25 1.25h18.5c.7 0 1.25-.56 1.25-1.25V2.75c0-.7-.56-1.25-1.25-1.25H2.75Zm7.46 6.46A.88.88 0 0 1 11.63 9l-1.55 2.14h6.68a.88.88 0 0 1 0 1.76h-6.75l1.64 2.41a.88.88 0 0 1-1.46 1l-2.58-3.8a.88.88 0 0 1 .02-1.01l2.58-3.54Z" clip-rule="evenodd"/>
            </svg>
        `;
    }
}
